import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ReplaceOutlinedStandard.js";
import l from "../components/PfIcon.js";
const e = (t, r) => {
  const a = {
    ...t,
    ...r.attrs
  };
  return n(l, o(a, {
    icon: d
  }), null);
};
e.displayName = "ReplaceOutlinedStandard";
e.inheritAttrs = !1;
export {
  e as default
};
